import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class LivetrackService {

    constructor(private dataService: DataService) {
    };

    get(refresh: Boolean) {
        return this.dataService.getData('/api/vehiclestatus', refresh);
    }

    getByVehicleId(vehicleId: number) {
        return this.dataService.getRecord('/api/vehiclestatus/vehicle/' + vehicleId);
    }

    getVehicleDetailById(vehicleId: number) {
        return this.dataService.getRecord('/api/vehicle/details/' + vehicleId);
    }

    getByClientId(regionId:number, divisionId:number, subdivisionId:number) {
        return this.dataService.getRecord('/api/vehiclestatus/vehicles/' + regionId+'/'+divisionId+'/'+subdivisionId);
    }

    getDashboardData(regionId: number, divisionId: number, subdivisionId: number) {
        return this.dataService.getRecord('/api/vehiclestatus/dashboard/' + regionId +'/'+ divisionId +'/'+ subdivisionId);
    }

    getClientList() {
        return this.dataService.getRecord('/api/client/lookupbyuser');
    }

    getAddress(lat, lng) {
        const url = 'https://nominatim.openstreetmap.org/search?format=json&q=' + lat + ',' + lng;
        return this.dataService.getExternalData(url);
    }

    getPotos(id:number, refresh:boolean) {
        return this.dataService.getData('/api/vehicle/photos/' + id, refresh);
    }
}
